import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';
import SectionHeader from './SectionHeader';

const rankTone = ['bg-primary-500 text-background-50', 'bg-accent-500 text-foreground-950', 'bg-secondary-500 text-background-50', 'bg-background-300 text-foreground-700', 'bg-background-300 text-foreground-700'];

export default function Trending() {
  const top = [...comics].sort((a, b) => Number(b.views.replace('万', '')) - Number(a.views.replace('万', ''))).slice(0, 5);
  return (
    <section className="section-pad bg-accent-100">
      <div className="container-page">
        <div className="grid gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <SectionHeader
              eyebrow="本周热榜"
              title="大家都在追的爆款"
              desc="按阅读量与点赞实时排名的热门作品，全网最火的笑点都在这。"
            />
            <div className="flex flex-col gap-3">
              {top.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-primary-300"
                >
                  <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl font-heading text-lg ${rankTone[index]}`}>
                    {index + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-700">{comic.title}</h3>
                    <p className="mt-0.5 flex items-center gap-2 text-xs text-foreground-600">
                      <span>{comic.category}</span>
                      <i className="ri-fire-line text-primary-500" aria-hidden="true" />
                      {comic.views} 阅读
                    </p>
                  </div>
                  <span className="hidden shrink-0 text-sm font-bold text-accent-700 sm:block">{comic.rating} 分</span>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="mb-8 flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                <i className="ri-magic-line text-xl" aria-hidden="true" />
              </span>
              <div>
                <h2 className="text-2xl text-foreground-950 md:text-3xl">魔性名场面</h2>
                <p className="text-sm text-foreground-600">看一遍就忘不掉的神级分镜</p>
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {top.slice(0, 4).map((comic) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="group relative aspect-[16/9] overflow-hidden rounded-2xl"
                >
                  <img
                    src={comic.cover}
                    alt={`${comic.title}名场面预览`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-4">
                    <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
                      <i className="ri-emotion-laugh-line" aria-hidden="true" />
                      {comic.category}
                    </span>
                    <h3 className="mt-2 text-base font-bold text-background-50">{comic.title}</h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}